import { useState, useEffect } from 'react'
import { supabase } from '../../lib/supabase'
import {
  fetchParentStudents,
  getActiveStudentId
} from '../../lib/parentStudents'

export default function ParentAttendance() {
  const [attendance, setAttendance] = useState([])
  const [student, setStudent] = useState(null)
  const [stats, setStats] = useState({
    present: 0,
    absent: 0,
    late: 0
  })
  const [loading, setLoading] = useState(true)

  useEffect(() => {
    async function fetchData() {
      const { data: { user } } = await supabase.auth.getUser()

      if (!user) {
        setLoading(false)
        return
      }

      const { students } =
        await fetchParentStudents(user.id)

      const activeId =
        getActiveStudentId(students)

      const activeStudent =
        students.find(s => s.id === activeId)

      if (!activeStudent) {
        setLoading(false)
        return
      }

      setStudent(activeStudent)

      const { data } = await supabase
        .from('attendance')
        .select('*')
        .eq('student_id', activeStudent.id)
        .order('date', {
          ascending: false
        })

      const rows = data || []

      setAttendance(rows)

      setStats({
        present: rows.filter(
          a => a.status === 'present'
        ).length,

        absent: rows.filter(
          a => a.status === 'absent'
        ).length,

        late: rows.filter(
          a => a.status === 'late'
        ).length
      })

      setLoading(false)
    }

    fetchData()

    window.addEventListener(
      'parent-student-changed',
      fetchData
    )

    return () => {
      window.removeEventListener(
        'parent-student-changed',
        fetchData
      )
    }
  }, [])

  const statusCfg = {
    present: {
      label: 'Present',
      cls: 'badge-success'
    },
    absent: {
      label: 'Absent',
      cls: 'badge-danger'
    },
    late: {
      label: 'Late',
      cls: 'badge-warning'
    },
  }

  if (loading) {
    return <div className="empty">Loading...</div>
  }

  return (
    <div>
      <h2 style={{
        fontSize: 20,
        fontWeight: 500,
        marginBottom: 8
      }}>
        Attendance
      </h2>

      {student && (
        <div style={{
          fontSize: 13,
          color: 'var(--text3)',
          marginBottom: 20
        }}>
          Showing attendance for{' '}
          <strong style={{ color: 'var(--text2)' }}>
            {student.name}
          </strong>
        </div>
      )}

      <div style={{
        display: 'flex',
        gap: 12,
        marginBottom: 16
      }}>
        {[
          {
            l: 'Present',
            v: stats.present,
            c: 'var(--success)',
            bg: 'var(--success-bg)'
          },
          {
            l: 'Absent',
            v: stats.absent,
            c: 'var(--danger)',
            bg: 'var(--danger-bg)'
          },
          {
            l: 'Late',
            v: stats.late,
            c: 'var(--warning)',
            bg: 'var(--warning-bg)'
          }
        ].map(s => (
          <div
            key={s.l}
            style={{
              flex: 1,
              background: s.bg,
              borderRadius: 12,
              padding: '12px',
              textAlign: 'center'
            }}
          >
            <div style={{
              fontSize: 26,
              fontWeight: 600,
              color: s.c
            }}>
              {s.v}
            </div>

            <div style={{
              fontSize: 12,
              color: s.c,
              fontWeight: 500
            }}>
              {s.l}
            </div>
          </div>
        ))}
      </div>

      {attendance.length === 0 ? (
        <div className="empty">
          No records
        </div>
      ) : (
        <div
          className="card"
          style={{
            padding: 0,
            overflow: 'hidden'
          }}
        >
          <table>
            <thead>
              <tr>
                <th>Date</th>
                <th>Status</th>
              </tr>
            </thead>

            <tbody>
              {attendance.map(a => (
                <tr key={a.id}>
                  <td style={{ fontWeight: 500 }}>
                    {a.date}
                  </td>

                  <td>
                    <span className={`badge ${
                      statusCfg[a.status]?.cls ||
                      'badge-warning'
                    }`}>
                      {statusCfg[a.status]?.label ||
                        a.status}
                    </span>
                  </td>
                </tr>
              ))}
            </tbody>
          </table>
        </div>
      )}
    </div>
  )
}